export const TYPES = {
  FILLED: 'filled',
  OUTLINED: 'outlined'
};
export default {
  TYPES
};
